import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useConfigContext } from "~/providers/ConfigContextProvider";

const VerticalSlider = dynamic(() => import("~/components/ui/VerticalSlider"));
const ListItemVideoOrAudio = dynamic(
  () => import("~/components/content/ListItemVideoOrAudio")
);
const VerticalSliderItemWithTeaser = dynamic(
  () => import("~/components/content/VerticalSliderItemWithTeaser")
);

export const RelatedContent = ({
  ids,
  excludeIds,
  relatedItems,
}: {
  ids: string[] | number[];
  excludeIds?: string[] | number[] | undefined;
  relatedItems?: any;
}) => {
  const [items, setItems] = useState<any>(relatedItems);
  const [onlyMedia, setOnlyMedia] = useState(false);
  const config = useConfigContext();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const controller =
      typeof AbortController !== "undefined"
        ? new AbortController()
        : undefined;

    const get = async () => {
      let exclude = Array.isArray(excludeIds) ? excludeIds : [];

      if (relatedItems?.length > 0) {
        exclude = [...exclude, ...relatedItems.map((item: any) => item.id)];
      }

      try {
        const response: any = await fetch(
          `${
            config.cmsUrl
          }/wp-content/plugins/ikon-custom/rest-api-related.php?count=${
            5 - (relatedItems?.length ?? 0)
          }&ids=${ids.join(",")}${
            exclude?.length ? `&excludeIds=${exclude.join(",")}` : ""
          }`,
          {
            signal: controller?.signal,
          }
        );
        const data = await response.json();
        if (data?.data?.length > 0) {
          const newItems = [
            ...(Array.isArray(items) ? items : []),
            ...data?.data.sort((a: any, b: any) => {
              const dA = a.acf.date_end ?? a.date.split(" ")?.shift() ?? "";
              const dB = b.acf.date_end ?? b.date.split(" ")?.shift() ?? "";
              if (dA < dB) return 1;
              if (dA > dB) return -1;
              return 0;
            }),
          ];
          setOnlyMedia(
            newItems.reduce((flag: boolean, item: any) => {
              if (!["video", "audio_file"].includes(item.type)) return false;

              return flag;
            }, true)
          );

          setItems(newItems);
        }
      } catch (err: any) {}
    };

    if (!relatedItems?.length || relatedItems?.length < 5) get();

    return () => {
      if (controller) {
        controller.abort();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {items?.length > 0 && (
        <VerticalSlider
          key={`related`}
          header="Related"
          hasNav
          spaceHeight={
            !onlyMedia
              ? {
                  base: [1, 2, 8],
                  mobile: [1, 2, 8],
                  tablet: [2, 3, 8],
                  desktop: [2, 3, 8],
                  screen: [2, 3, 8],
                }
              : {
                  base: "auto",
                  mobile: "auto",
                  tablet: "auto",
                  desktop: "auto",
                  screen: "auto",
                }
          }
        >
          {items?.map((item: any, index: number) => {
            if (["video", "audio_file"].includes(item.type))
              return (
                <ListItemVideoOrAudio
                  item={item}
                  key={`related-${index + 1}`}
                  inVerticalSlider
                />
              );

            return (
              <VerticalSliderItemWithTeaser
                item={item}
                key={`related-${index + 1}`}
              />
            );
          })}
        </VerticalSlider>
      )}
    </>
  );
};
